import { render, staticRenderFns } from "./DfpForPopup.vue?vue&type=template&id=5aed5226&"
import script from "./DfpForPopup.vue?vue&type=script&lang=js&"
export * from "./DfpForPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports